module.exports = __webpack_public_path__ + "static/media/PASSO_A_PASSO_CONFIGURACAO_CENTERCHAT.f3c3d942.pdf";